import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import MaskedInput from 'react-text-mask';
var MASK_CHARS_MAP = {
  '#': /\d/,
  '?': /\d/,
  '@': /[a-zA-Z]/,
  '*': /\d[a-zA-Z]/
};
/** @param {string} mask */

var parseMask = function parseMask(mask) {
  if (!mask) return [];
  var maskArray = [];
  mask.split('').forEach(function (part) {
    var maskChar = MASK_CHARS_MAP[part] || part;
    maskArray.push(maskChar);
  });
  return maskArray;
};
/** @param {string} mask */


var createPlaceholderFromMask = function createPlaceholderFromMask(mask) {
  if (!mask) return '';
  return mask.replace(/#/g, '_').replace(/\?/g, '_').replace(/@/g, '_').replace(/\*/g, '_');
};

var MaskedText = function MaskedText(props) {
  var inputRef = props.inputRef,
      mask = props.mask,
      other = _objectWithoutProperties(props, ["inputRef", "mask"]);

  var maskArray = parseMask(mask);
  var placeholder = createPlaceholderFromMask(mask);
  return React.createElement(MaskedInput, Object.assign({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: maskArray,
    placeholder: placeholder,
    showMask: true,
    guide: false
  }));
};

export default MaskedText;